"use client";

import React from "react";
import CtaBand from "@/components/common/CtaBand";
import { useLanguage } from "@/hooks/useLanguage";
import { pick, type Lang } from "@/lib/i18n";
interface CtaCopy {
  eyebrow: string;
  heading: string;
  lead: string;
  primaryLabel: string;
  secondaryLabel: string;
}
const copyData: Record<Lang, CtaCopy> = {
  en: {
    eyebrow: "B2B Technical Support",
    heading: "Discuss Your Filtration Specifications With Our Engineers",
    lead: "Share your target mesh count, alloy requirements, or technical drawings for rapid engineering review and competitive volume pricing.",
    primaryLabel: "Request a Quote",
    secondaryLabel: "Contact Technical Team"
  },
  zh: {
    eyebrow: "B2B 技术支持",
    heading: "与我们的工程师探讨您的过滤规格与技术要求",
    lead: "向我们的工程团队提供您的目数、合金材质要求或技术图纸，即可获得快速技术评审与具竞争力的批量报价。",
    primaryLabel: "索取报价",
    secondaryLabel: "联系技术团队"
  },
  es: {
    eyebrow: "Soporte técnico B2B",
    heading: "Consulte sus especificaciones de filtración con nuestros ingenieros",
    lead: "Comparta su número de malla, requisitos de aleación o planos técnicos para una revisión técnica ágil y precios competitivos por volumen.",
    primaryLabel: "Solicitar presupuesto",
    secondaryLabel: "Contactar al equipo técnico"
  },
  de: {
    eyebrow: "Technischer B2B-Support",
    heading: "Besprechen Sie Ihre Filtrationsspezifikationen mit unseren Ingenieuren",
    lead: "Teilen Sie uns Maschenzahl, Legierungsanforderungen oder technische Zeichnungen für eine zügige Prüfung und wettbewerbsfähige Mengenpreise mit.",
    primaryLabel: "Angebot anfragen",
    secondaryLabel: "Technisches Team kontaktieren"
  },
  fr: {
    eyebrow: "Support technique B2B",
    heading: "Examinez vos spécifications de filtration avec nos ingénieurs",
    lead: "Transmettez votre compte de mailles, vos exigences d'alliage ou vos plans techniques pour une étude technique rapide et une tarification compétitive.",
    primaryLabel: "Demander un devis",
    secondaryLabel: "Contacter l'équipe technique"
  },
  pt: {
    eyebrow: "Suporte técnico B2B",
    heading: "Discuta suas especificações de filtração com nossos engenheiros",
    lead: "Compartilhe sua contagem de malha, requisitos de liga ou desenhos técnicos para uma rápida avaliação e preços competitivos por volume.",
    primaryLabel: "Solicitar orçamento",
    secondaryLabel: "Falar com a equipe técnica"
  }
};
export default function ClosingCta() {
  const {
    lang
  } = useLanguage();
  const content = pick(lang, copyData);
  return <CtaBand id="closingcta" eyebrow={content.eyebrow} heading={content.heading} lead={content.lead} primary={{
    label: content.primaryLabel,
    to: "/RequestAQuotePage"
  }} secondary={{
    label: content.secondaryLabel,
    to: "/ContactPage"
  }} />;
}